var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLowPrice = function SvgLowPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lowPrice_svg__a)",
    fillRule: "evenodd",
    d: "M11.4 12.827H9.616a.2.2 0 0 0-.15.333l3.555 3.999a.2.2 0 0 0 .299 0l3.555-3.999a.2.2 0 0 0-.15-.333H14.92C14.676 6.13 8.953.774 1.928.774Q.945.774 0 .91c6.273.7 11.175 5.735 11.4 11.917",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lowPrice_svg__a",
    x1: 0,
    x2: 16.924,
    y1: 9,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF475D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0F23"
  })))));
};
export default SvgLowPrice;